module.exports = __webpack_public_path__ + "img/full1-min.41d6ebce.png";